import { Text } from '@usealloy/component-library';
import styled from 'styled-components';
import type { OutcomeOptionMeta } from './types';

export const StyledDropdownSingleValueText = styled(Text) <Pick<OutcomeOptionMeta, 'color'>>`
  &&& {
    font-family: var(--cl-font-family-mono);
    width: fit-content;
    line-height: var(--cl-line-height-1);
    font-weight: bold;
    ${({ color }) => color && `border-bottom: 2px solid ${color};`};
  }
`;

